
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insight/list",
      function () {
        return require("private-next-pages/insight/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insight/list"])
      });
    }
  